// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".transport-dialog .common-btn{height:36px;background:rgba(255,102,0,.05);border:1px solid #ca4300;border-radius:4px;font-size:14px;color:#ca4300;line-height:34px;padding:0 17px;cursor:pointer;display:inline-block}.transport-dialog .common-btn.is-disabled{color:#c0c4cc;cursor:not-allowed;background-image:none;background-color:#fff;border-color:#ebeef5}", ""]);
// Exports
module.exports = exports;
